import auth from "../middleware/auth";


export default [
  {
    path: "/expertise/:id",
    name: "index",
    component: () => import("./../views/ekspertiza/detailExpertise/detailsMain.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
          title: "Home",
          url: "/"
        },

        {
          i18n: "navmenu.statistic.ekspertiza",
          title: "Экспертиза",
          active: true
        },

      ]
    },

    pageTitle: "Front",
    rule: "editor"
  },
  {
    path: "/expertise/details/:id",
    name: "index",
    component: () => import("./../views/ekspertiza/detailExpertise/details.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
          title: "Home",
          url: "/"
        },

        {
          i18n: "navmenu.statistic.ekspertiza",
          title: "Экспертиза",
          active: true
        },
        {
          title: "Подробности",
          i18n: "ex_details",
          active: true
        }
      ]
    },

    pageTitle: "Front",
    rule: "editor"
  },
  {
    path: "/expertise",
    name: "index",
    component: () => import("./../views/ekspertiza/ekspertiza.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
          title: "Home",
          url: "/"
        },

        {
          i18n: "navmenu.statistic.ekspertiza",
          title: "Экспертиза",
          active: true
        }
      ]
    },

    pageTitle: "Front",
    rule: "editor"
  },
  {
    path: "/base/index",
    name: "index",
    component: () => import("./../views/defaultPage.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
          title: "Home",
          url: "/"
        },

        {
          i18n: 'main_page',
          active: true
        }
      ]
    },

    pageTitle: "Front",
    rule: "editor"
  },
  {
    path: "/dictionary/others",
    name: "Dictionary",
    component: () => import("./../views/dictionary/Others.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
          title: "Home",
          url: "/"
        },
        {
          title: "Справочники и классификаторы",
          i18n: 'spra',
          active: false
        },
        {
          i18n: 'others',
          title: "Прочие",
          active: true
        }
      ]
    },

    pageTitle: "Front",
    rule: "editor"
  },
  {
    path: "/dictionary/objects",
    name: "Dictionary_Objects",
    component: () => import("./../views/dictionary/Objects.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
          title: "Home",
          url: "/"
        },
        {
          title: "Ввод даных",
          i18n: "data_input",
          active: false
        },
        {
          title: "Объекты",
          i18n: "objects",
          active: true
        }
      ]
    },

    pageTitle: "Front",
    rule: "editor"
  },
  {
    path: "/dictionary/settingsObject/addObject",
    name: "Add_Objects",
    component: () =>
      import("./../views/dictionary/settingsObject/addObject.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
          title: "Home",
          url: "/"
        },
        {
          title: "Ввод даных",
          i18n: "data_input",
          active: false
        },
        {
          title: "Объекты",
          i18n: "objects",
          url: "/dictionary/objects"
        },
        {
          title: "Добавление объекта",
          i18n: "add_ob",
          active: true
        }
      ]
    },

    pageTitle: "Front",
    rule: "editor"
  },
  {
    path: "/dictionary/settingsObject/edit_objects/:id",
    name: "editObjects",
    component: () =>
      import("./../views/dictionary/settingsObject/editObject.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
          title: "Home",
          url: "/"
        },
        {
          title: "Ввод даных",
          i18n: "data_input",
          active: false
        },
        {
          title: "Объекты",
          i18n: "objects",
          url: "/dictionary/objects"
        },
        {
          title: "Редактирование объекта",
          i18n: "edit_ob",
          active: true
        }
      ]
    },

    pageTitle: "Edit-Object",
    rule: "editor"
  }
];
